import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Experience = () => {
  const { t } = useLanguage();
  const experiences = t('experiences');

  return (
    <section className="section section--tint">
      <div className="wrap split">
        <h2 className="split__label">{t('experienceTitle')}</h2>
        <div className="entries">
          {experiences.map((exp) => (
            <article key={`${exp.date}-${exp.title}`} className="entry">
              <p className="entry__when">{exp.date}</p>
              <div>
                <h3 className="entry__title">{exp.title}</h3>
                <p className="entry__org">{exp.company}</p>
                <p className="entry__lead">{exp.description}</p>
                {exp.achievements.length > 0 && (
                  <ul className="entry__points" aria-label={t('keyAchievements')}>
                    {exp.achievements.map((achievement) => (
                      <li key={achievement}>{achievement}</li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
